import { api } from './client'

const rateTableService = {
  getRateTables: (objectId) => api.get('/rate-tables', objectId ? { objectId } : {}),
  getDefaultRateTable: (objectId) => api.get('/rate-tables/default', { objectId }),
  getRateTable: (id) => api.get(`/rate-tables/${id}`),
  getRateTableEntries: (id, { versionId, objectId, getDefault } = {}) =>
    api.get(`/rate-tables/${id}/entries`, { versionId, objectId, getDefault }),
  getVersions: (id, past = true) => api.get(`/rate-tables/${id}/versions`, { past }),
  getVersion: (versionId, rateTableId) => api.get(`/rate-tables/version/${versionId}`, { rateTableId }),
  getUsage: (id) => api.get(`/rate-tables/${id}/usage`),
  getTimekeepers: () => api.get('/rate-tables/timekeepers'),
}

export default rateTableService
